export const environment = {
  production: false,
  BASE_URL: 'https://xbp.uat.volant-ubicomms.com/api/v1',
  userName: 'xbp-partner-token',
  // partnerAPIToken: 'All', // XBP
  // partnerAPIToken: '8FAF5766-D2F8-4B5A-9185-8C2FF301CBEC', // NationRemit
  // partnerAPIToken: 'E9E96C17-CD00-4C80-B80B-3649B9B65738', // yarksh
  partnerAPIToken: 'B1DF9AE3-AE6D-4F7B-AC08-58778F551FC2', // mellapay

  // partnerAPIToken: '1EF9FED7-71BF-4586-9614-9B0F989FFB9F', // Bunna
  // partnerAPIToken: 'DC0A67F4-21A3-44D8-851B-B0E105B04FB1', // Vitpay

  // Account-deletion page config (per-partner) — replace placeholders before go-live
  partnerName: 'Mellapay', // TODO: set per partner
  supportEmail: 'support@mellapay.com', // TODO: set per partner (deletion request email)
  dataRetentionYears: 7, // TODO: confirm with partner compliance (regulatory retention)
};
